var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@naturehouse/design-system/components/protons/icon/Icon.macro.njk"] = require( "@naturehouse/design-system/components/protons/icon/Icon.macro.njk" );
dependencies["@naturehouse/design-system/components/atoms/loader/Spinner.macro.njk"] = require( "@naturehouse/design-system/components/atoms/loader/Spinner.macro.njk" );




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/organisms/card-house-extra-costs-info-button.macro.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["houseId", "priceStartDate", "priceEndDate"], 
[], 
function (l_houseId, l_priceStartDate, l_priceEndDate, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("houseId", l_houseId);
frame.set("priceStartDate", l_priceStartDate);
frame.set("priceEndDate", l_priceEndDate);
var t_2 = "";t_2 += "\n    ";
env.getTemplate("@naturehouse/design-system/components/protons/icon/Icon.macro.njk", false, "templates/components/organisms/card-house-extra-costs-info-button.macro.njk", false, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
t_3.getExported(function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
context.setVariable("iconTemplate", t_3);
t_2 += "\n    ";
env.getTemplate("@naturehouse/design-system/components/atoms/loader/Spinner.macro.njk", false, "templates/components/organisms/card-house-extra-costs-info-button.macro.njk", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
t_6.getExported(function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
context.setVariable("spinnerTemplate", t_6);
t_2 += "\n\n    <button\n        type=\"button\"\n        class=\"nh-info-tip\"\n        data-role=\"extra-costs-dialog-toggle\"\n        data-target-house-id=\"";
t_2 += runtime.suppressValue(l_houseId, env.opts.autoescape);
t_2 += "\"\n        data-arrival-date=\"";
t_2 += runtime.suppressValue(l_priceStartDate, env.opts.autoescape);
t_2 += "\"\n        data-departure-date=\"";
t_2 += runtime.suppressValue(l_priceEndDate, env.opts.autoescape);
t_2 += "\"\n    >\n        ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 12, colno = 30, runtime.callWrap(runtime.memberLookup((t_3),"render"), "iconTemplate[\"render\"]", context, [{"name": "info","size": "0.75","data": {"data-role": "extra-costs-dialog-toggle-icon"}}]))), env.opts.autoescape);
t_2 += "\n        ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 19, colno = 33, runtime.callWrap(runtime.memberLookup((t_6),"render"), "spinnerTemplate[\"render\"]", context, [{"variant": "light","classes": ["hidden"],"data": {"data-role": "extra-costs-dialog-toggle-spinner"}}]))), env.opts.autoescape);
t_2 += "\n    </button>\n";
})})})});
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("render");
context.setVariable("render", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/organisms/card-house-extra-costs-info-button.macro.njk"] , dependencies)